<p-toast position="bottom-right"></p-toast>
<div class="p-fluid p-formgrid grid" autocomplete="off">
  <ng-template ngFor let-fieldGroup [ngForOf]="formConfig" let-groupIndex="index">
    <div class="p-field col-12 title" *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex]
                    &&fieldGroup.group&&fieldGroup.group.length>0">
      <p-divider align="left" type="solid">
        <div class="inline-flex align-items-center">
          <i class="fas fa-cog p-mr-2"></i>
          <b>{{ 'page.' + transPartKey + '.form.group_title.' + fieldGroup.group | translate }}</b>
        </div>
      </p-divider>
    </div>
    <ng-template ngFor let-fieldConfig [ngForOf]="fieldGroup.fields" let-fieldIndex="index"
                 *ngIf="!fieldValueMap['hiddenGroup-' + groupIndex]">
      <div
        *ngIf="formRecord&&!fieldValueMap['hiddenField-'+ groupIndex+'_' + fieldIndex]
        &&(formRecord[fieldConfig.field]||(fieldConfig.mapValue&&fieldValueMap['mapValue-'+ groupIndex+'_' + fieldIndex]))"
        [class]="'field p-field p-field-value col-12 md:col-'+fieldConfig.column">
        <!--        LABEL -->
        <label *ngIf="fieldConfig.field" [for]="fieldConfig.field"
               [className]="fieldConfig.required===true?'field-required':''">
          {{fieldConfig.label ? fieldConfig.label : 'page.' + this.transPartKey + '.form.' + fieldConfig.field | translate}}
        </label>
        <!--        CHECKBOX Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.CHECKBOX"><i [class]="'fa-solid fa-square'
            + (formRecord[fieldConfig.field]?'-check':'')"></i></div>
        <!--        TEXT Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.TEXT || fieldConfig.type===FieldTypes.EMAIL"
             (click)="copiedToClipboard()"
             [cdkCopyToClipboard]="fieldConfig.mapValue?fieldValueMap['mapValue-'+ groupIndex+'_' + fieldIndex]:formRecord[fieldConfig.field]"
             [pTooltip]="fieldConfig.mapValue?fieldValueMap['mapValue-'+ groupIndex+'_' + fieldIndex]:formRecord[fieldConfig.field]">
          {{fieldConfig.mapValue ? fieldValueMap['mapValue-'+ groupIndex+'_' + fieldIndex] : formRecord[fieldConfig.field]}}</div>
        <!--        INTERGER/DECIMAL Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.INTEGER || fieldConfig.type===FieldTypes.DECIMAL"
             (click)="copiedToClipboard()"
             [cdkCopyToClipboard]="formRecord[fieldConfig.field]| number:fieldConfig.format ? fieldConfig.format : '1.0-7'"
             [pTooltip]="formRecord[fieldConfig.field]| number:fieldConfig.format ? fieldConfig.format : '1.0-7'">
          {{formRecord[fieldConfig.field]| number:fieldConfig.format ? fieldConfig.format : '1.0-7'}}</div>

        <!--        PASSWORD Field -->

        <!--        TEXTAREA Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.TEXTAREA">
          {{formRecord[fieldConfig.field]}}</div>
        <!--        AUTOCOMPLETE Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.AUTOCOMPLETE">
          {{formRecord[fieldConfig.field]}}</div>
        <!--        DROPDOWN Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.DROPDOWN">
          {{(fieldValueMap['options-'+ groupIndex+'_' + fieldIndex] | findOptionTextPipe: formRecord[fieldConfig.field])}}</div>
        <!--        MULTISELECT Field -->
        <ul *ngIf="fieldConfig.type===FieldTypes.MULTISELECT">
          <li *ngFor="let value of formRecord[fieldConfig.field]">{{value}}}}</li>
        </ul>
        <!--        MULTITEXT Field -->
        <ul *ngIf="fieldConfig.type===FieldTypes.MULTITEXT">
          <li *ngFor="let value of formRecord[fieldConfig.field]"
          >{{(fieldValueMap['options-'+ groupIndex+'_' + fieldIndex] | findOptionTextPipe: value)}}</li>
        </ul>
        <!--        MULTILISTBOX Field -->
        <ul *ngIf="fieldConfig.type===FieldTypes.LISTBOX">
          <li *ngFor="let value of formRecord[fieldConfig.field]"
          >{{(fieldValueMap['options-'+ groupIndex+'_' + fieldIndex] | findOptionTextPipe: value)}}</li>
        </ul>
        <!--        CRON Field -->
        <div *ngIf="fieldConfig.type===FieldTypes.CRON">
          {{formRecord[fieldConfig.field]}}</div>
        <!--        Date -->
        <div *ngIf="fieldConfig.type===FieldTypes.DATE"
             (click)="copiedToClipboard()"
             [cdkCopyToClipboard]="formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'dd/MM/yyyy')"
             [pTooltip]="formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'dd/MM/yyyy')">
          {{formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'dd/MM/yyyy')}}</div>
        <!--        DateTime -->
        <div *ngIf="fieldConfig.type===FieldTypes.DATETIME"
             (click)="copiedToClipboard()"
             [cdkCopyToClipboard]="formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'dd/MM/yyyy HH:mm:ss')"
             [pTooltip]="formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'dd/MM/yyyy HH:mm:ss')">
          {{formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'dd/MM/yyyy HH:mm:ss')}}</div>
        <!--        Time -->
        <div *ngIf="fieldConfig.type===FieldTypes.TIME"
             (click)="copiedToClipboard()"
             [cdkCopyToClipboard]="formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'HH:mm:ss')"
             [pTooltip]="formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'HH:mm:ss')">
          {{formRecord[fieldConfig.field] | date:(fieldConfig.format ? fieldConfig.format : 'HH:mm:ss')}}</div>
        <!--        RichField -->
        <cc-readonly-rich-field #ccSubDetail *ngIf="fieldConfig.type===FieldTypes.RICHFIELD"
                                [fieldName]="'page.' + transPartKey + '.form.' + fieldConfig.field | translate"
                                [formRecords]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:[])"
                                [formRichFieldConfig]="fieldConfig.richFieldConfig"
                                [transPartKey]="transPartKey"
                                [required]="fieldConfig.required===true"
                                [hidden]="fieldConfig.hidden?fieldValueMap['hiddenField-'+ groupIndex+'_' + fieldIndex]:false">
        </cc-readonly-rich-field>

        <!--        single RichField -->

        <!--        MapField -->
        <cc-readonly-map-field #ccSubDetail *ngIf="fieldConfig.type===FieldTypes.MAPFIELD"
                               [fieldName]="'page.' + transPartKey + '.form.' + fieldConfig.field | translate"
                               [formRecordMap]="(formRecord[fieldConfig.field]?formRecord[fieldConfig.field]:{})"
                               [transPartKey]="transPartKey"
        >
        </cc-readonly-map-field>
      </div>
    </ng-template>
  </ng-template>
</div>
